// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZnEdn{position:fixed;bottom:80px;left:0;width:220px;z-index:100;display:flex;flex-direction:column;gap:8px;padding:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tasksDrawer": `ZnEdn`
};
export default ___CSS_LOADER_EXPORT___;
